import { IS_PRODUCTION } from '@repo/common-utils';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { ReactElement } from 'react';

import { SectionScrollModelProvider } from '@/components/common/context/SectionScrollModelProvider';
import { CustomPageContent } from '@/components/landing/CustomPageContent';
import { CustomPageDataType, CustomPageProps } from '@/lib/types/custom-page';
import { useRemoteConfig } from '@/lib/web/core/use-firebase';
import NotFound from '@/pages/404';

export const getServerSideProps: GetServerSideProps<CustomPageProps> = (async (context) => {
  const { params } = context;

  if (!params?.content || typeof params?.content !== 'string') {
    return {
      notFound: true
    };
  }

  return {
    props: {
      id: params.content
    }
  };
}) satisfies GetServerSideProps<CustomPageProps>;

const EventContentPage = ({ id }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const data = useRemoteConfig('CUSTOM_PAGE')?.[IS_PRODUCTION ? 'prd' : 'dev']?.event as CustomPageDataType;

  return (
    <>
      {data?.[id] ? (
        <CustomPageContent
          id={id}
          viewEvent={data?.[id].viewEvent}
          button={data?.[id].button}
          sections={data?.[id].sections}
          defaultSection={data?.[id].defaultSection}
        />
      ) : data ? (
        <NotFound />
      ) : (
        <></>
      )}
    </>
  );
};

EventContentPage.getLayout = (page: ReactElement) => <SectionScrollModelProvider>{page}</SectionScrollModelProvider>;

export default EventContentPage;
